import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';
import AudienceSwitch from './AudienceSwitch';

const Header = () => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-gray-900 text-white py-4 px-6">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="flex items-center space-x-3">
          <img src="/img/brand/isotipo-web.png" alt="" className="h-10" />
          <img src="/img/brand/logotipo-web.png" alt="Tenku" className="h-6" />
          <AudienceSwitch className="tk-audience--desktop" />
        </div>

        <nav className="hidden md:flex space-x-8 items-center">
          <a href="#features">{t('header.features')}</a>
          <a href="#how-it-works">{t('header.howItWorks')}</a>
          <a href="#testimonials">{t('header.testimonials')}</a>
          <a href="#faq">{t('header.faq')}</a>
          <a href={t('downloads.webLink')} className="border border-gray-600 hover:border-brand hover:text-brand rounded-lg px-4 py-1.5 font-semibold transition-colors">
            {t('header.openWeb')}
          </a>
          <LanguageSelector />
        </nav>

        <div className="md:hidden flex items-center space-x-2">
          <LanguageSelector />
          <button
            onClick={toggleMenu}
            className="text-white hover:text-brand transition-colors p-2 -mr-2"
          >
            {isMenuOpen ? (
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>

      <div className="tk-audience-row">
        <AudienceSwitch />
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden mt-4 pb-4">
          <nav className="flex flex-col space-y-3">
            <a href="#features" onClick={closeMenu} className="text-gray-300 hover:text-brand transition-colors py-2">
              {t('header.features')}
            </a>
            <a href="#how-it-works" onClick={closeMenu} className="text-gray-300 hover:text-brand transition-colors py-2">
              {t('header.howItWorks')}
            </a>
            <a href="#testimonials" onClick={closeMenu} className="text-gray-300 hover:text-brand transition-colors py-2">
              {t('header.testimonials')}
            </a>
            <a href="#faq" onClick={closeMenu} className="text-gray-300 hover:text-brand transition-colors py-2">
              {t('header.faq')}
            </a>
            <a href={t('downloads.webLink')} className="text-brand font-semibold py-2">
              {t('header.openWeb')}
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;